import { render, staticRenderFns } from "./RemoveSitePresence.vue?vue&type=template&id=b8e684f0&scoped=true"
import script from "./RemoveSitePresence.js?vue&type=script&lang=js&external"
export * from "./RemoveSitePresence.js?vue&type=script&lang=js&external"
import style0 from "./RemoveSitePresence.scss?vue&type=style&index=0&id=b8e684f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e684f0",
  null
  
)

export default component.exports